export class ReportStatus {
    openRequests?: number = 0;
    overDueRequests?: number = 0;
    overDueInSevenDays?: number = 0;
    overDueInFourteenDays?: number = 0;
    overDueInThirtyDays?: number = 0;
    urgentInPastThirtyDays?: number = 0;
    submittedInPastSevenDays?: number = 0;
    closedOrCancelledInPastSevenDays?: number = 0;
}

export class FacilityDD{
    id?: number = 0;
    field?: string = "";
    facilities?: string = "";
    isActive?: boolean = false;
}